import { render, staticRenderFns } from "./consultingServiceList.vue?vue&type=template&id=45da5cbe&scoped=true&"
import script from "./consultingServiceList.vue?vue&type=script&lang=js&"
export * from "./consultingServiceList.vue?vue&type=script&lang=js&"
import style0 from "./consultingServiceList.vue?vue&type=style&index=0&id=45da5cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da5cbe",
  null
  
)

export default component.exports